import React, { Suspense, lazy, useState } from 'react';
import LoadingIntro from '../components/LoadingIntro';
import GridOverlay from '../components/GridOverlay';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Solutions from '../components/Solutions';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import LazySection from '../components/LazySection';

// Below-the-fold sections are code-split so the initial JS bundle stays
// lean. They are wrapped in <LazySection> so the component (and any
// API calls it makes on mount) only loads when the user scrolls near it.
const FranchiseLocator = lazy(() => import('../components/FranchiseLocator'));
const Testimonials = lazy(() => import('../components/Testimonials'));
const FAQ = lazy(() => import('../components/FAQ'));
const Clients = lazy(() => import('../components/Clients'));
const Cases = lazy(() => import('../components/Cases'));
const Eneaflix = lazy(() => import('../components/Eneaflix'));
const Blog = lazy(() => import('../components/Blog'));
const ContactCTA = lazy(() => import('../components/ContactCTA'));

const Home = () => {
  const [showLoading, setShowLoading] = useState(true);

  return (
    <>
      <SEO
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Instituto Eneagrama',
          url: 'https://ie-interactive.emergent.host',
          logo: 'https://customer-assets.emergentagent.com/job_b2005392-6212-4506-b62b-d5c77af4b77a/artifacts/n8p0qeqa_Logomarca_Horizontal_Preta.png',
          sameAs: [
            'https://www.instagram.com/ieneagramabr',
            'https://www.linkedin.com/school/institutoeneagramabrasil',
            'https://www.youtube.com/@IEneagrama',
          ],
        }}
      />
      {showLoading && <LoadingIntro onComplete={() => setShowLoading(false)} />}
      <div className={`transition-opacity duration-500 ${showLoading ? 'opacity-0' : 'opacity-100'}`}>
        <GridOverlay />
        <Header />
        <main id="main-content">
          {/* Above-the-fold — eager */}
          <Hero />
          <About />
          <Solutions />

          {/* Below-the-fold — lazy-mounted on scroll */}
          <Suspense fallback={null}>
            <LazySection minHeight={900}>
              <FranchiseLocator compact />
            </LazySection>
            <LazySection minHeight={700}>
              <Testimonials />
            </LazySection>
            <LazySection minHeight={500}>
              <FAQ />
            </LazySection>
            <LazySection minHeight={400}>
              <Clients />
            </LazySection>
            <LazySection minHeight={700}>
              <Cases />
            </LazySection>
            <LazySection minHeight={900}>
              <Eneaflix />
            </LazySection>
            <LazySection minHeight={700}>
              <Blog />
            </LazySection>
            <LazySection minHeight={600}>
              <ContactCTA />
            </LazySection>
          </Suspense>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Home;
